module.exports = __webpack_public_path__ + "img/3066864-32-9.9643d234.png";